import markerBlue from '../images/hatchback.png';

/** Build marker labels as text so API data is never parsed as HTML. */
export const createMarkerElement = (result, lastSeen) => {
    const el = document.createElement('div');
    el.className = 'marker';

    const img = document.createElement('img');
    img.src = markerBlue;
    img.style.width = '30px';
    img.style.height = '30px';

    const label = document.createElement('p');
    label.textContent = result.vehicleReference;
    label.style.fontSize = '11px';
    label.style.textAlign = 'center';
    label.style.width = '150px';
    el.appendChild(label);
    el.appendChild(img);

    const tooltip = document.createElement('p');
    tooltip.className = 'marker-tooltip';
    tooltip.appendChild(document.createTextNode(result.vehicleReference));
    tooltip.appendChild(document.createElement('br'));
    tooltip.appendChild(document.createTextNode(`Last Position: ${lastSeen}`));
    tooltip.style.textAlign = 'center';
    tooltip.style.width = '150px';
    tooltip.style.display = 'none';
    el.appendChild(tooltip);

    el.addEventListener('mouseenter', () => {
        tooltip.style.display = 'block';
    });
    el.addEventListener('mouseleave', () => {
        tooltip.style.display = 'none';
    });

    return el;
};

/** Keep references inside one URL path segment and build links without HTML parsing. */
export const createVehiclePopupContent = (vehicleReference) => {
    const content = document.createElement('div');
    content.className = 'dark-popup';
    const referenceSegment = encodeURIComponent(vehicleReference);

    for (const [path, label] of [['deviceOverview', 'Overview'], ['vehicles', 'Journeys']]) {
        const link = document.createElement('a');
        link.href = `/${path}/${referenceSegment}`;
        const button = document.createElement('button');
        button.type = 'button';
        button.textContent = label;
        link.appendChild(button);
        content.appendChild(link);
    }

    return content;
};
